import * as React from 'react'
import { Link } from 'react-router-dom'

export interface LogoProps {
  /**
   * Whether the mark links home. Default true — in the header it is the standard
   * "back to the start" affordance.
   *
   * The startup error page passes `false`: the app behind it was never mounted, so
   * navigating to `/` would leave the visitor on the very same page, having spent a
   * focus stop on a link that does nothing. There the mark is branding, not a
   * control, and it renders as plain markup with no router dependency.
   */
  linked?: boolean;
}

const Mark: React.FC = () => (
  <div id='logo'>
    <svg
      version='1.1' className='Logo__svg' viewBox='0 0 399 121' fill='none'
      xmlns='http://www.w3.org/2000/svg' aria-hidden='true' focusable='false'
    >
      <g id='Group 3'>
        <path
          id='medialib' fillRule='evenodd' clipRule='evenodd'
          d='M55.3504 56.5055C61.4217 56.5055 63.3443 61.7673 63.3443 68.3446V93.8442H78.6238V65.6125C78.6238 52.9638 72.4513 42.4402 57.3741 42.4402C49.5826 42.4402 44.1184 45.6782 41.1839 48.6127C37.6423 44.7675 32.7852 42.4402 26.8151 42.4402C22.5651 42.4402 18.214 43.958 15.2795 46.2854V43.2497H0V93.8442H15.2795V60.553C17.3033 58.0233 20.339 56.5055 23.6782 56.5055C29.7496 56.5055 31.6721 61.7673 31.6721 68.3446V93.8442H46.9517V65.6125C46.9517 63.9934 46.7493 62.4756 46.5469 60.9578C48.5707 58.2257 51.9099 56.5055 55.3504 56.5055ZM113.736 80.6896C119.099 80.6896 122.54 78.0587 124.564 74.3147L136.706 82.511C132.052 89.7966 123.855 94.6537 113.838 94.6537C100.481 94.6537 88.0344 84.13 88.0344 68.5469C88.0344 53.6722 98.5581 42.4402 114.141 42.4402C126.992 42.4402 138.528 50.8389 138.528 66.8267C138.528 68.2434 138.427 69.7612 138.224 71.279H102.707C103.415 78.0587 109.183 80.6896 113.736 80.6896ZM113.23 54.6841C109.588 54.6841 104.225 56.3031 102.808 62.3744H123.451C122.641 57.0114 118.189 54.6841 113.23 54.6841ZM145.409 68.5469C145.409 54.684 154.92 42.4402 169.896 42.4402C174.045 42.4402 178.093 43.8568 181.027 46.2854V22H196.307V93.8442H181.027V90.9097C178.093 93.3382 174.045 94.6537 169.896 94.6537C154.92 94.6537 145.409 82.4098 145.409 68.5469ZM172.426 80.6896C176.17 80.6896 178.902 79.273 181.027 76.5409V60.6542C178.902 57.9221 176.17 56.4043 172.426 56.4043C165.14 56.4043 160.789 61.8685 160.789 68.547C160.789 75.2254 165.14 80.6896 172.426 80.6896ZM207.842 93.8442H223.223V43.2498H207.842V93.8442ZM207.842 36.9253H223.223V22.0505H207.842V36.9253ZM322 36.8748H337.381V22H322V36.8748ZM232.836 68.5469C232.836 54.6841 242.348 42.4402 257.324 42.4402C261.472 42.4402 265.52 43.8568 268.454 46.2854V43.2497H283.734V93.8442H268.454V90.9097C265.52 93.3382 261.472 94.6537 257.324 94.6537C242.348 94.6537 232.836 82.4098 232.836 68.5469ZM259.853 80.6896C263.597 80.6896 266.329 79.273 268.454 76.5409V60.6542C266.329 57.9221 263.597 56.4043 259.853 56.4043C252.568 56.4043 248.217 61.8685 248.217 68.547C248.217 75.2254 252.568 80.6896 259.853 80.6896ZM293.268 120H313.268V0H293.268V120ZM322 93.5945H337.381V43H322V93.5945ZM398 68.5469C398 82.4098 388.488 94.6537 373.512 94.6537C369.364 94.6537 365.316 93.3382 362.381 90.9097V93.8442H347.102V22H362.381V46.2854C365.316 43.8568 369.364 42.4402 373.512 42.4402C388.488 42.4402 398 54.684 398 68.5469ZM372.983 80.6896C380.268 80.6896 384.619 75.2254 384.619 68.547C384.619 61.8685 380.268 56.4043 372.983 56.4043C369.239 56.4043 366.405 57.9221 364.381 60.6542V76.5409C366.405 79.273 369.239 80.6896 372.983 80.6896Z'
          transform='translate(0.911987 0.639893)' fill='white'
        />
      </g>
    </svg>
  </div>
)

const Logo: React.FC<LogoProps> = ({ linked = true }) => (
  linked
    ? (
      <Link to='/' className='Logo' aria-label='medialib.tv — home'>
        <Mark />
      </Link>
      )
    : (
      <div className='Logo Logo--static'>
        <Mark />
      </div>
      )
)

export default Logo
